import { version as reactVersion } from 'react';
import { version as reduxVersion } from 'redux/package.json';
import { version as muiCoreVersion } from '@material-ui/core/package.json';

import configureStoreDev from './configureStore.dev';
import configureStoreProd from './configureStore.prod';

import { logStyle } from '../styles/logStyles';

import logger from '../utils/logger';
import { isDevEnv } from '../utils/statePersistenceControl';

const ENVIRONMENTS = {
  local: 'local',
  localhost: 'localhost',
  localhostIp: '127.0.0.1',
  dev: 'dev',
  development: 'development',
  uat: 'uat',
  production: 'production',
};

const getEnvironmentContext = () => {
  if (process.env.ENV) {
    return process.env.ENV;
  }

  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    if (hostname === ENVIRONMENTS.localhost || hostname === ENVIRONMENTS.localhostIp) {
      return ENVIRONMENTS.local;
    }
    if (hostname.includes(`${ENVIRONMENTS.dev}.`)) {
      return ENVIRONMENTS.dev;
    }
    if (hostname.includes(`${ENVIRONMENTS.uat}.`)) {
      return ENVIRONMENTS.uat;
    }
  }

  return ENVIRONMENTS.production;
};

const ENV_CONTEXT = getEnvironmentContext();

const EFFECTIVE_NODE_ENV = [ENVIRONMENTS.local, ENVIRONMENTS.dev].includes(ENV_CONTEXT)
  ? ENVIRONMENTS.development
  : ENVIRONMENTS.production;

logger.info(`running env: { mode: '${EFFECTIVE_NODE_ENV}', context: '${ENV_CONTEXT}'}`);

const configureStore = (() => {
  if (EFFECTIVE_NODE_ENV === ENVIRONMENTS.development || isDevEnv()) {
    const react = `v${reactVersion}`;
    const redux = `v${reduxVersion}`;
    const mui = `v${muiCoreVersion}`;

    logger.info(
      '\n%c       🔧 DEVELOPMENT MODE         %c\n' +
        `%c          React → ${react}        %c\n` +
        `%c          Redux → ${redux}         %c\n` +
        `%c          Mui → ${mui}          %c\n\n\n`,
      logStyle.header,
      logStyle.reset,
      logStyle.react,
      logStyle.reset,
      logStyle.redux,
      logStyle.reset,
      logStyle.mui,
      logStyle.reset,
    );
    return configureStoreDev;
  }
  return configureStoreProd;
})();

export default configureStore;
